import { render, staticRenderFns } from "./RptZipReport.vue?vue&type=template&id=490ede50&"
import script from "./RptZipReport.vue?vue&type=script&lang=js&"
export * from "./RptZipReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports